import type { OpportunityTask } from 'backend/types'
import { useMemo } from 'react'

export interface UseTasksFilterOptions {
  tasks: OpportunityTask[] | undefined
  searchText: string
}

/**
 * タスク一覧のテキスト検索フィルタリングを行うフック
 *
 * 複数フィールドに対して大文字小文字を無視した部分一致検索を行う。
 */
export function useTasksFilter(options: UseTasksFilterOptions) {
  const { tasks, searchText } = options

  const filteredTasks = useMemo(() => {
    if (!tasks) return []
    if (!searchText) return tasks

    const lowerSearch = searchText.toLowerCase()
    return tasks.filter((task) => {
      const searchableFields = [
        task.title,
        task.description,
        task.opportunity_id?.toString(),
        task.opportunity_title,
        task.opportunity_status_name,
        task.salesforce_project_name,
        task.expired_on,
        task.expired_on?.replace(/(\d{4})-(\d{2})-(\d{2})/, '$1年$2月$3日'),
        task.opportunity_task_status_name,
        task.updated_by_name,
        task.created_by_name,
      ]

      return searchableFields.some((field) =>
        String(field || '')
          .toLowerCase()
          .includes(lowerSearch),
      )
    })
  }, [tasks, searchText])

  return { filteredTasks }
}
